const config = {
  apiUrl: process.env.REACT_APP_API_URL ?? 'https://staging-api.hetheraengineering.com/',
  callbackUrlBase:
    process.env.REACT_APP_API_URL ?? 'https://staging-api.hetheraengineering.com/',
};

export default config;
